<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KKN6111","phone":"18200946810","carCode":"","credits":"10","billCode":"20170901140630384"},
            responseCode: {"data":{},"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台扣减用户积分",
                t_url: this.commonUrls.test+"reduceUserCredits",
                p_url: this.commonUrls.prod+"reduceUserCredits",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '用户手机号（与车牌号必填一个）' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号（与手机号必填一个）' },
                        { info1: 'credits', info2: '是', info3: 'int', info4: '扣减的积分数' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '流水号' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/score/reduceUserCredits.vue